import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import AuthService from 'lib/AuthService';
import localStore from 'lib/LocalStore';
import { BigBlueButton, StyledInputWithLabel } from 'lib/styles';

const LoginContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	transition: opacity 0.5s ease-out;
`;

const LoginForm = styled.form`
	position: relative;
	width: 500px;
	padding: 48px;
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 0px 8px -2px rgba(0,0,0,0.1), 0px 24px 80px -32px rgba(0,0,0,0.15);
	margin: 0 0 40px 0;
`;

const ErrorMessage = styled.h5`
	color: red;
	background-color: rgba(255,0,0,0.1);
	padding: 16px 16px;
	border-radius: 4px;
	text-align: center;
`;

const Button = styled(BigBlueButton)`
	margin: 50px auto 0;

	&:disabled {
		background-color: rgb(230,230,230);
		box-shadow: none;
	}
`;

const AdditionalActionsContainer = styled.div`
	width: 500px;
	display: flex;
	justify-content: space-evenly;
`;

const ChangeLanguage = styled.a`
	color: rgba(74,144,226,1);
	text-decoration: underline;
	cursor: pointer;
`;

const ForgotPassword = styled(Link)`
	color: rgba(74,144,226,1);
`;

const Logo = styled.div`
	margin: 0 0 48px;
	width: 100%;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		height: 48px;
	}
`;

const logo = require(`!raw-loader!../assets/${'logo-black'}.svg`);

class Login extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();

		this.state = {
			username: '',
			password: '',
			loading: true,
			loggingIn: false,
			error: null,
		}

		if (this.Auth.loggedIn()) {
			this.props.history.replace(`/${this.props.lng}/t/`);
		}
	}

	componentDidMount() {
		this.setState({ loading: false });
	}

	handleInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value,
			error: null,
		});
	}

	handleInputBlur(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleSubmit(event) {
		event.preventDefault();

		const { lng } = this.props;

		this.setState({ loggingIn: true });

		const newState = { ...this.state };

		Array.from(event.target.elements).forEach(input => {
			if (input.name in this.state) {
				newState[input.name] = input.value;
			}
		});

		this.Auth.login(newState.username, newState.password)
			.then(response => {
				if (
					response.status === 'ok' &&
					response.result.user.username === newState.username
				) {
					this.setState({
						loading: true,
						loggingIn: false,
						error: null,
						username: '',
						password: '',
						...newState
					});

					const loggedOutFrom = localStore.get('loggedOutFrom');

					localStore.clear('loggedOutFrom');

					this.props.history.replace(loggedOutFrom ? loggedOutFrom : `/${lng}/t/`);
				}
			})
			.catch(error => {
				this.setState({ loading: false, loggingIn: false, error: 'login/error' });
			});
	}

	render() {
		const { t, lng, i18n, history } = this.props;
		const buttonText = this.state.loggingIn ? t('login/Logging in') : t('login/Log in');

		const changeLanguage = language => {
			i18n.changeLanguage(language);

			const path = window.location.pathname.split('/');
			path[1] = language;

			localStore.set({ language });

			history.push(path.join('/'));
		};

		return (
			<LoginContainer style={{ opacity: this.state.loading ? 0.3 : 1 }}>
				<LoginForm onSubmit={(event) => this.handleSubmit(event)}>

					<Logo dangerouslySetInnerHTML={{__html: logo }} />

					<h1 style={{marginTop: 0}}>{t('login/Log in')}</h1>

					<StyledInputWithLabel
						label={t('login/username')}
						type="email"
						defaultValue={this.state.username}
						placeholder={t('login/username/placeholder')}
						name="username"
						onChange={event => this.handleInputChange(event)}
						onBlur={event => this.handleInputBlur(event)}
					/>

					<StyledInputWithLabel
						label={t('login/password')}
						type="password"
						defaultValue={this.state.password}
						placeholder="••••"
						name="password"
						onChange={event => this.handleInputChange(event)}
						onBlur={event => this.handleInputBlur(event)} />

					{ this.state.error &&
						<ErrorMessage>{t(this.state.error)}</ErrorMessage>
					}

					<Button
						type="submit"
						disabled={this.state.loggingIn || this.state.username === '' || this.state.password === ''}
					>{buttonText}</Button>
				</LoginForm>
				<AdditionalActionsContainer>
					<ForgotPassword to={`/${lng}/t/password/`}>{t('login/new password')}</ForgotPassword>
					<ForgotPassword to={`/${lng}/t/password/`}>{t('login/forgot password')}</ForgotPassword>
					<ChangeLanguage onClick={() => changeLanguage(t('app/Other language'))}>{t('app/Other language name')}</ChangeLanguage>
				</AdditionalActionsContainer>
			</LoginContainer>
		);
	}
}

Login.propTypes = {
	history: PropTypes.object,
	t: PropTypes.any,
	lng: PropTypes.string,
	i18n: PropTypes.any,
}

export default translate('translations')(withRouter(Login));

export {
	LoginContainer,
	LoginForm,
	ErrorMessage,
	Button,
	Logo,
}
